module.exports = __webpack_public_path__ + "static/img/qualifications_row_9.77c91ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_9.png
// module id = 5Tq3
// module chunks = 1